import Vue from 'vue'
import Vuex from 'vuex'
import { dataSource } from "@/api/api.js";
Vue.use(Vuex)
let store = new Vuex.Store({
	state:{
		entNavState:'',
		companyName:'',
		searchData:'',
		updatePasswordPhone:'',
		updatePasswordVcode:'',
        newsType:'',//新闻信息
		// 用户信息
		userInfo: {
			username: '',
			updateTime: '',
			companyId: ''
		},

		// 注册
		registerMsg: {
			username: '',
			password: ''
		},

		// 认证用户信息
		authInfo: {
			logo: ''
		},
	},
	mutations:{
		// 保存登录信息
		updateRegisterMsg(state, opt) {
			state.registerMsg = {
				username: opt.username,
				password: opt.password
			};
		},

		// 保存企业信息
		updateCompanyInfo(state, opt) {
			state.userInfo.username = opt.username;
			state.userInfo.updateTime = opt.updateTime;
			state.userInfo.companyId = opt.companyId;
		},
		// 清除企业信息
		clearCompanyInfo(state) {
			state.userInfo.username = '';
			state.userInfo.updateTime = '';
			state.userInfo.companyId = '';
		},

		// 保存认证用户信息
		updateAuthInfo(state, opt) {
			state.authInfo.logo = opt.logo;
		},

		updataNavState(state,payload){ //企业状态
			state.entNavState = payload;
		},
		updataCompanyName(state,payload){ //企业名称
			state.companyName = payload;
		},
        updataNewsType(state,payload){ //新闻类型
			state.newsType = payload;
		},
		updataSearch(state,payload){ //搜索
			state.searchData = payload;//
		},
		updatePasswordPhone(state,payload){ //忘记密码下一步参数
			state.phone = payload;//
		},
		updatePasswordVcode(state,payload){ //忘记密码下一步参数
			state.vcode = payload;//
		},
	},
	getters:{

	},
	actions: {
		getCompanyInfo({commit}) {
			dataSource.postGetCompanyUserInfo().then(res => {
				let data = res.data.data;
				commit('updateCompanyInfo', {
					username: data.userName,
					updateTime: data.updateTime,
					companyId: data.id
				})
			}).catch(err => {
				this.$message.error(err)
			})
		},
		getAuthInfo({commit}) {
			return new Promise((resolve, reject) => {
				dataSource.getAuthInfo().then(res => {
					let data = res.data.data;

					commit('updateAuthInfo', {
						logo: data.logo
					});

					resolve(res)

				}).catch(err => {
					this.$message.error(err)
				})
			})

		}
	}
})

export default store
